
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { OfferSingle } from "@/services/offers/OfferSingle";
import OfferCard from "@/components/offers/offer/OfferCard.vue";
import { eventBus } from "@/eventbus";
import Status from "@/components/base/Status.vue";
import SvgPrivateOffer from "@/assets/icons/private-offer.svg";
import BaseSelect from "@/components/base/design/BaseSelect.vue";
import { IOfferGoal } from "@/api/types/offers";
import { translateBoolean, translateGoalStatus, translateOffersStatus } from "@/utils/translate";
import BaseDateTimePicker from "@/components-UI/BaseDateTimePicker.vue";
import BaseSwitch from "@/components-UI/BaseSwitch.vue";
import { canEditOffers } from "@/utils/checkRole";

@Component({
    methods: { translateBoolean },
    components: {
        BaseSwitch,
        BaseDateTimePicker,
        BaseSelect,
        SvgPrivateOffer,
        Status,
        OfferCard,
    },
})

export default class GoalMain extends Vue {
    get canEditOffer(): boolean {
        return canEditOffers();
    }

    @Prop({ required: true }) offer!: OfferSingle | null;
    @Prop({ required: true }) goal!: IOfferGoal;
    @PropSync('isLoading') isLoadingSync!: boolean;

    translateOffersStatus = translateOffersStatus;
    translateGoalStatus = translateGoalStatus;

    statusItems = [
        { id: true },
        { id: false },
    ];
    protocolItems = [
        { id: 'postback', text: 'Постбек' },
        { id: 'pixel', text: 'Пиксель' },
    ];
    protocolKey = 0;
    isEdit = false;
    offerGoalData: { name: string, value: any, type: string }[] = [];

    @Watch('goal', { deep: true, immediate: true })
    preparedOfferGoalData(): void {
        if (!this.offerGoalData.length && this.goal) {
            this.offerGoalData = [
                { name: 'Название оффера', value: `${this.offer?.legacy_id} ${this.offer?.name}`, type: 'offer-title' },
                { name: 'Статус оффера', value: this.offer?.status, type: 'offer-status' },
                { name: 'Статус цели', value: this.goal.active, type: 'active' },
                { name: 'Название цели', value: this.goal.name, type: 'name' },
                { name: 'Способ трекинга', value: this.goal.protocol, type: 'protocol' },
                { name: 'Автоподт. конверсии', value: this.goal.approve_conversions, type: 'approve_conversions' },
                { name: 'Приватность', value: this.goal.private, type: 'private' },
                { name: 'Эндпоинт', value: this.goal.endpoint, type: 'endpoint' },
                { name: 'Начало действия', value: '', type: 'action_date' },
            ];
        }
    }

    get getStatusItems(): { id: boolean, text: string }[] {
        return this.statusItems.map(i => {
            return { id: i.id, text: translateGoalStatus(i.id).text };
        });
    }

    editInfo(edit: boolean): void {
        if (!edit) {
            this.updateAllOfferGoalData();
        }

        this.isEdit = edit;
    }

    setDefaults(edit: boolean): void {
        this.offerGoalData[2].value = this.goal.active;
        this.offerGoalData[3].value = this.goal.name;
        this.offerGoalData[4].value = this.goal.protocol;
        this.offerGoalData[5].value = this.goal.approve_conversions;
        this.offerGoalData[6].value = this.goal.private;
        this.offerGoalData[7].value = this.goal.endpoint;
        this.offerGoalData[8].value = '';
        this.isEdit = edit;
    }

    async updateAllOfferGoalData(): Promise<void> {
        this.isLoadingSync = true;
        const formattedData: { [key: string]: any } = this.offerGoalData.slice(2).reduce((acc, item) => {
            if (item.type) {
                acc[item.type] = item.value;
            }

            return acc;
        }, {});

        const isOfferGoalDataSaved = await this.offer?.editGoal({ ...this.goal, ...formattedData });

        if (isOfferGoalDataSaved) {
            this.offerGoalData[8].value = '';
            eventBus.$emit("update-goal");
        }

        this.isLoadingSync = false;
    }
}
